(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-insight"] && !Shopify.designMode) return;
  try {
    /*
    Derives a card background color from its image: samples the image on a tiny
    canvas, finds the most representative color and returns a pastel tint of it
    so black text stays readable. Neutral images fall back to a warm gray.
  */
  (() => {
    const SIZE = 32;
    const cache = new Map();

    const rgbToHsl = (r, g, b) => {
      r /= 255;
      g /= 255;
      b /= 255;
      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      const l = (max + min) / 2;
      if (max === min) return [0, 0, l];
      const d = max - min;
      const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      let h;
      if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) * 60;
      else if (max === g) h = ((b - r) / d + 2) * 60;
      else h = ((r - g) / d + 4) * 60;
      return [h, s, l];
    };

    /*
      Clusters the sampled pixels (k-means in RGB), then scores each cluster by
      how much of the image it covers and how saturated it is, so a large muted
      area and a smaller vivid accent both get a fair chance.
    */
    const K = 5;
    const ITERATIONS = 8;

    const dominantTint = (img) => {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = SIZE;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      let data;
      try {
        ctx.drawImage(img, 0, 0, SIZE, SIZE);
        data = ctx.getImageData(0, 0, SIZE, SIZE).data;
      } catch (error) {
        return null;
      }

      const pixels = [];
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 128) continue;
        pixels.push([data[i], data[i + 1], data[i + 2]]);
      }
      if (pixels.length < 16) return null;

      // Seed centroids evenly across the luminance range
      const sorted = [...pixels].sort((a, b) => a[0] + a[1] + a[2] - (b[0] + b[1] + b[2]));
      let centroids = Array.from({ length: K }, (_, k) => [...sorted[Math.floor(((k + 0.5) / K) * sorted.length)]]);
      let assignment = new Array(pixels.length).fill(0);

      for (let iter = 0; iter < ITERATIONS; iter++) {
        pixels.forEach((px, idx) => {
          let best = 0;
          let bestDist = Infinity;
          centroids.forEach((c, k) => {
            const d = (px[0] - c[0]) ** 2 + (px[1] - c[1]) ** 2 + (px[2] - c[2]) ** 2;
            if (d < bestDist) {
              bestDist = d;
              best = k;
            }
          });
          assignment[idx] = best;
        });
        const sums = Array.from({ length: K }, () => [0, 0, 0, 0]);
        pixels.forEach((px, idx) => {
          const sum = sums[assignment[idx]];
          sum[0] += px[0];
          sum[1] += px[1];
          sum[2] += px[2];
          sum[3] += 1;
        });
        centroids = sums.map((sum, k) => (sum[3] ? [sum[0] / sum[3], sum[1] / sum[3], sum[2] / sum[3]] : centroids[k]));
      }

      const counts = new Array(K).fill(0);
      assignment.forEach((k) => counts[k]++);

      let best = null;
      centroids.forEach((c, k) => {
        const share = counts[k] / pixels.length;
        if (share < 0.04) return;
        const [h, sat, l] = rgbToHsl(c[0], c[1], c[2]);
        // Very dark or very bright clusters make poor card tints
        const usable = l > 0.12 && l < 0.92 ? 1 : 0.4;
        const score = share * (0.35 + sat) * usable;
        if (!best || score > best.score) best = { score, h, sat };
      });
      if (!best) return null;

      if (best.sat < 0.08) return 'hsl(40 6% 91%)';
      const sat = Math.min(42, Math.max(18, best.sat * 100));
      return `hsl(${best.h.toFixed(0)} ${sat.toFixed(0)}% 90%)`;
    };

    const paint = (img) => {
      const card = img.closest('[data-card-tint]');
      if (!card || !img.naturalWidth) return;
      const key = img.currentSrc || img.src;
      let color = cache.get(key);
      if (!color) {
        color = dominantTint(img);
        if (!color) return;
        cache.set(key, color);
      }
      card.style.setProperty('--card-bg', color);
    };

    document.addEventListener(
      'load',
      (event) => {
        if (event.target instanceof HTMLImageElement && event.target.hasAttribute('data-card-palette')) {
          paint(event.target);
        }
      },
      true
    );

    document.querySelectorAll('img[data-card-palette]').forEach((img) => {
      if (img.complete) paint(img);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const actionEl = event.target.closest('[data-card-action]');
    if (!actionEl) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'product_card_action',
      cardAction: actionEl.dataset.cardAction,
      productId: actionEl.dataset.productId,
      productTitle: actionEl.dataset.productTitle,
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-featured-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var viewports = document.querySelectorAll('[data-featured-gallery-embla]');
    viewports.forEach(function (viewport) {
      if (!window.EmblaCarousel) {
        return;
      }
      EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var galleryTriggers = document.querySelectorAll('[data-fancybox="product-gallery"]');

    galleryTriggers.forEach(function (trigger) {
      trigger.addEventListener('mousedown', function (event) {
        // Avoid pointer focus jumping the Embla viewport while keeping keyboard focus behavior intact.
        event.preventDefault();
      });
    });

    if (window.Fancybox && window.Compactmode && !Fancybox.Plugins.Compactmode) {
      Fancybox.Plugins.Compactmode = Compactmode;
    }

    if (window.Fancybox) {
      var has3d = document.querySelector('[data-has-3d]');

      var fancyboxOptions = {
        mainClass: 'bg-white',
        placeFocusBack: false,
        autoFocus: false,
        Compactmode: {
          mediaQuery: '(max-width: 768px), (max-height: 700px)'
        },
        Thumbs: false,
        Carousel: {
          Thumbs: false
        },
        caption: false
      };

      if (has3d) {
        fancyboxOptions.Carousel.Toolbar = {
          display: {
            left: ['infobar'],
            middle: [],
            right: ['view3d', 'iterateZoom', 'slideshow', 'fullscreen', 'close']
          },
          items: {
            view3d: {
              tpl: '<button class="f-button" title="3D View" style="gap:6px;width:auto;padding:0 12px;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2"/><path d="m15.194 13.707 3.814 1.86-1.86 3.814"/><path d="M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4"/></svg><span style="font-size:11px;font-weight:500;white-space:nowrap;text-transform:uppercase;">3D Görünüm</span></button>',
              click: function () {
                Fancybox.close();
                window.dispatchEvent(new CustomEvent('open-3d-modal'));
              }
            }
          }
        };
      }

      Fancybox.bind('[data-fancybox="product-gallery"]', fancyboxOptions);
    }

    var emblaRoots = document.querySelectorAll('[data-embla]');
    emblaRoots.forEach(function (root) {
      var viewport = root.querySelector('[data-embla-viewport]');
      if (!viewport || !window.EmblaCarousel) {
        return;
      }

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        slidesToScroll: 1,
        duration: 20,
        breakpoints: {
          '(min-width: 1024px)': { slidesToScroll: 3 }
        }
      });

      var prevBtn = root.querySelector('[data-embla-prev]');
      var nextBtn = root.querySelector('[data-embla-next]');

      if (prevBtn) prevBtn.addEventListener('click', function() { embla.scrollPrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { embla.scrollNext(); });

      var progressNode = root.querySelector('[data-embla-progress]');
      var progressTrack = root.querySelector('[data-embla-progress-track]');
      if (!progressNode) {
        return;
      }

      var updateProgress = function () {
        var progress = embla.scrollProgress();
        var clampedProgress = Math.max(0, Math.min(1, progress));
        
        // Map 0-1 progress to a fill that starts at 15% and ends at 100%
        var minFill = 0.15;
        var fill = minFill + (clampedProgress * (1 - minFill));
        
        progressNode.style.transform = 'scaleX(' + fill + ')';
      };

      embla.on('scroll', updateProgress);
      embla.on('reInit', updateProgress);
      updateProgress();

      if (!progressTrack) {
        return;
      }

      var snapList = embla.scrollSnapList();
      var isPointerDown = false;

      var findClosestSnap = function (progress) {
        var closestIndex = 0;
        var closestDistance = Math.abs(snapList[0] - progress);
        snapList.forEach(function (snap, index) {
          var distance = Math.abs(snap - progress);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      };

      var moveToProgress = function (event) {
        var rect = progressTrack.getBoundingClientRect();
        var raw = (event.clientX - rect.left) / rect.width;
        var clamped = Math.max(0, Math.min(1, raw));
        var index = findClosestSnap(clamped);
        embla.scrollTo(index);
      };

      var onPointerDown = function (event) {
        isPointerDown = true;
        progressTrack.setPointerCapture(event.pointerId);
        moveToProgress(event);
      };

      var onPointerMove = function (event) {
        if (!isPointerDown) {
          return;
        }
        moveToProgress(event);
      };

      var onPointerUp = function (event) {
        if (!isPointerDown) {
          return;
        }
        isPointerDown = false;
        progressTrack.releasePointerCapture(event.pointerId);
      };

      progressTrack.addEventListener('pointerdown', onPointerDown);
      progressTrack.addEventListener('pointermove', onPointerMove);
      progressTrack.addEventListener('pointerup', onPointerUp);
      progressTrack.addEventListener('pointercancel', onPointerUp);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-element"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('video[data-mobile-sources]').forEach(function (video) {
    var useMobile = window.matchMedia(video.dataset.mobileMedia || '(max-width: 767px)').matches;

    if (useMobile) {
      video.querySelectorAll('source').forEach(function (s) { s.remove(); });
      video.dataset.mobileSources.split(',').forEach(function (entry) {
        var parts = entry.split('|');
        var source = document.createElement('source');
        source.src = parts[0];
        if (parts[1]) source.type = parts[1];
        video.appendChild(source);
      });
      if (video.dataset.mobilePoster) video.poster = video.dataset.mobilePoster;
    }

    video.preload = video.dataset.preload || 'auto';
    video.load();

    if (video.hasAttribute('data-autoplay')) {
      video.autoplay = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-unmute-button"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.video-unmute-btn').forEach(function (btn) {
    var container = btn.parentElement;
    var video = container.querySelector('video');
    if (!video) return;

    var mutedIcon = btn.querySelector('.video-unmute-btn__icon--muted');
    var unmutedIcon = btn.querySelector('.video-unmute-btn__icon--unmuted');
    var idleTimer = null;
    var IDLE_DELAY = 3000;

    function updateIcons() {
      if (video.muted) {
        mutedIcon.classList.remove('hidden');
        unmutedIcon.classList.add('hidden');
      } else {
        mutedIcon.classList.add('hidden');
        unmutedIcon.classList.remove('hidden');
      }
    }

    function resetIdleTimer() {
      btn.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        btn.classList.add('is-idle');
      }, IDLE_DELAY);
    }

    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      updateIcons();
      resetIdleTimer();
    });

    container.addEventListener('mousemove', resetIdleTimer);
    container.addEventListener('touchstart', resetIdleTimer, { passive: true });

    updateIcons();
    resetIdleTimer();
  });
  } catch(e) { console.error(e); }
})();

})();
